import React from 'react'
import RoleWiseLogs from '../Logs/RoleWiseLogs'

const SuperAdminLogs = () => {
    return(
        <RoleWiseLogs role="superadmin" title="Super Admin"></RoleWiseLogs>
    )
}

export default SuperAdminLogs